import { AuthenticationContext, adalFetch, withAdalLogin } from 'react-adal';


export const adalConfig = {
    tenant: process.env.REACT_APP_TENANT,
    clientId: process.env.REACT_APP_CLIENTID,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_POSTLOGOUTURI,
    //redirectUri: 'https://rpsuat.southeastasia.cloudapp.azure.com/PhotoSystemWeb/AzureLogin',
    //postLogoutRedirectUri: 'https://rpsuat.southeastasia.cloudapp.azure.com/PhotoSystemWeb',
    endpoints: {
      api: process.env.REACT_APP_ENDPOINTAPI,
    },
    cacheLocation: 'localStorage'
};


export const authContext = new AuthenticationContext(adalConfig);

export const adalApiFetch = (fetch, url, options) =>
  adalFetch(authContext, adalConfig.endpoints.api, fetch, url, options);
 
export const withAdalLoginApi = withAdalLogin(authContext, adalConfig.endpoints.api);

export const getToken = () => authContext.getCachedToken(adalConfig.clientId);

export const clearCache = () => authContext.clearCache();

export const getCachedUser = () => authContext.getCachedUser();






